const api = {
  GET_LIST_MERCHANT: '/index.php?r=api/v1/user_merchant/merchant/index',
  BLOCK_MERCHANT_USER: '/index.php?r=api/v1/user_merchant/merchant/block',
  UNBLOCK_MERCHANT_USER: '/index.php?r=api/v1/user_merchant/merchant/unblock',
  UPDATE_MERCHANT_USER: '/index.php?r=api/v1/user_merchant/merchant/update',
  BIOMETRIC_STATUS: '/index.php?r=api/v1/user_merchant/merchant/biometric-status',
  GET_DETAIL_MERCHANT: '/index.php?r=api/v1/user_merchant/merchant/view',
};

export default api;